import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';


import DealInsights2 from './pages/DealInsights2.jsx';
import NotFound from './components/NotFound';
// import Battlecard from './components/Battlecard';
// import BattlecardForm from './components/BattlecardForm';
import ROI from './components/ROI.jsx';
import HsHome from './pages/HsHome.jsx';
import Battlecard from './pages/collateral/Battlecard.jsx';
import BattlecardResult from './pages/collateral/BattlecardResult.jsx';
import CompanyTest2 from './pages/companyInsights/CompanyTest.jsx';
import Login from './pages/Login.jsx';
import AuthCallback from './pages/CallBack.jsx';
import { useAuth } from './context/AuthContext.js';
import Collateral from './pages/collateral/collateral.jsx';
import Test from './pages/Test.jsx';
import CustomCollateral from './pages/CustomCollateral.jsx';
import CustomCollateral2 from './pages/CustomCollateral2.jsx';
import TailspinAgentic from './pages/tailspin/TailspinAgentic.jsx';
import CollateralGeneration from './pages/CollateralGeneration.jsx';
import OnboardingStep1 from './pages/tailspin/OnboardingStep1.jsx';
import OnboardingStep2 from './pages/tailspin/OnboardingStep2.jsx';
import OnboardingStep2New from './pages/tailspin/OnboardingStep2New.jsx';
import OnboardingStep3 from './pages/tailspin/OnboardingStep3.jsx';
import TailspinDashboard from './pages/tailspin/TailspinDashboard.jsx';
import TailspinCollateralCreate from './pages/tailspin/TailspinCollateralCreate.jsx';
import TailspinOnboardingGuard from './components/TailspinOnboardingGuard.jsx';
import TailspinCollateral from './pages/tailspin/TailspinCollateral.jsx';
import HtmlCollateral from './pages/tailspin/HtmlCollateral.jsx';
import HtmlCollateralCreate from './pages/tailspin/HtmlCollateralCreate.jsx';
import HtmlPublicCollateral from './pages/tailspin/HtmlPublicCollateral.jsx';
import TailspinPublicCollateral from './pages/tailspin/TailspinPublicCollateral.jsx';
import TailspinProspectCollateral from './pages/tailspin/TailspinProspectCollateral.jsx';
//import CodeFirstCollateral from './pages/tailspin/CodeFirstCollateral.jsx';
import BrandAssetsPage from './pages/tailspin/BrandAssetsPage.jsx';
import UserIntelligence from './pages/tailspin/UserIntelligence.jsx';
import SuperAdminRoute from './components/SuperAdminRoute.jsx';
import AdminDashboard from './pages/admin/AdminDashboard.jsx';
import TailspinLayout from './components/tailspin/TailspinLayout.jsx';
import CrmDataSync   from './pages/crmAnalysis/CrmDataSync.jsx';
import CrmAnalysis   from './pages/crmAnalysis/CrmAnalysis.jsx';
import { CrmAnalysisProvider } from './context/CrmAnalysisContext.js';
import ManageSubscription from './pages/subscription/ManageSubscription.jsx';
import SubscriptionSuccess from './pages/subscription/SubscriptionSuccess.jsx';
import SubscriptionCancel from './pages/subscription/SubscriptionCancel.jsx';


function App() {

  const ProtectedRoute = ({ children }) => {
    const { user, loading, isInExtension } = useAuth();
    const location = useLocation();

    if (loading) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="spinner"></div>
        </div>
      );
    }

    const isOnboardingRoute = location.pathname.startsWith('/tailspin/onboarding');
    const isBattlecardRoute = location.pathname.startsWith('/battlecard');
    const isDashboardRoute = location.pathname.startsWith('/tailspin/dashboard');

    if (!user) {
      return <Navigate to="/login" />;
    }

    // Only redirect to onboarding if user explicitly needs onboarding (brand new user)
    // Dashboard is allowed even if not onboarded (product tour will show)
    if (user.needsOnboarding && !isOnboardingRoute && !isBattlecardRoute && !isInExtension) {
      return <Navigate to="/tailspin/onboarding/step1" replace />;
    }


    return children;
  };

  // Public Route Component (redirect if authenticated)
  const PublicRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="spinner"></div>
        </div>
      );
    }

    return !user ? children : <Navigate to="/" />;
  };





  return (
    <Router>
      <CrmAnalysisProvider>
      <div style={{ fontFamily: 'sans-serif', minWidth: 420 }}>
        <Routes>


          <Route path="/login" element={<PublicRoute><Login /></PublicRoute >} />
          <Route path="/callback" element={<AuthCallback />} />

          <Route path="/" element={<ProtectedRoute><HsHome /></ProtectedRoute >} />



          <Route path="/deal-insights" element={<ProtectedRoute><DealInsights2 /></ProtectedRoute >} />
          
          {/* Public routes for shareable collateral */}
          <Route path="/html/:slug" element={<HtmlPublicCollateral />} />
          <Route path="/prospect/:slug" element={<TailspinProspectCollateral />} />
          <Route path="/:tenantdomain/:slug" element={<TailspinPublicCollateral />} />

          <Route path="/company-insights-test" element={<ProtectedRoute><CompanyTest2 /></ProtectedRoute >} />

          {/* <Route path="/battlecard" element={<ProtectedRoute><BattlecardForm /></ProtectedRoute >} />
          <Route path="/battlecard/:version/:companyVsCompetitor" element={<ProtectedRoute><Battlecard /></ProtectedRoute >} />
          */}
          {/* <Route path="/collateral/battlecard/:key" element={<ProtectedRoute><Collateral_BC /></ProtectedRoute >} /> */}

          <Route path="/battlecard" element={<ProtectedRoute><Battlecard /></ProtectedRoute >} />
          <Route path="/battlecard/:key" element={<ProtectedRoute><BattlecardResult /></ProtectedRoute >} />
          <Route path="/tailspin_collateral/:key" element={<Collateral />} />
          <Route path="/test" element={<Test />} />
          <Route path="/test2/:key" element={<CustomCollateral2 />} />
          <Route path="/roi" element={<ROI />} />
          <Route path="/tailspin-agentic" element={<ProtectedRoute><CollateralGeneration /></ProtectedRoute >} />
          <Route path="/tailspin-agentic/:slug" element={<ProtectedRoute><TailspinAgentic /></ProtectedRoute >} />
          {/* Tailspin Onboarding Routes */}
          <Route path="/tailspin/onboarding/step1" element={<ProtectedRoute><OnboardingStep1 /></ProtectedRoute>} />
          <Route path="/tailspin/onboarding/step2" element={<ProtectedRoute><OnboardingStep2New /></ProtectedRoute>} />
          <Route path="/tailspin/onboarding/step3" element={<ProtectedRoute><OnboardingStep3 /></ProtectedRoute>} />
          <Route path="/tailspin/onboarding/step2-old" element={<ProtectedRoute><OnboardingStep2 /></ProtectedRoute>} />

          {/* Tailspin Protected Routes with Onboarding Guard and Layout */}
          <Route path="/tailspin/dashboard" element={
            <ProtectedRoute>
              <TailspinOnboardingGuard>
                <TailspinLayout>
                  <TailspinDashboard />
                </TailspinLayout>
              </TailspinOnboardingGuard>
            </ProtectedRoute>
          } />
          <Route path="/tailspin/collateral" element={
            <ProtectedRoute>
              <TailspinOnboardingGuard>
                <TailspinLayout>
                  <TailspinCollateralCreate />
                </TailspinLayout>
              </TailspinOnboardingGuard>
            </ProtectedRoute>
          } />
          <Route path="/tailspin/collateral/:slug" element={
            <ProtectedRoute>
              <TailspinOnboardingGuard>
                <TailspinLayout>
                  <TailspinCollateral />
                </TailspinLayout>
              </TailspinOnboardingGuard>
            </ProtectedRoute>
          } />
          <Route path="/tailspin/brand-assets" element={
            <ProtectedRoute>
              <TailspinOnboardingGuard>
                <TailspinLayout>
                  <BrandAssetsPage />
                </TailspinLayout>
              </TailspinOnboardingGuard>
            </ProtectedRoute>
          } />
          <Route path="/tailspin/user-intelligence" element={
            <ProtectedRoute>
              <TailspinOnboardingGuard>
                <TailspinLayout>
                  <UserIntelligence />
                </TailspinLayout>
              </TailspinOnboardingGuard>
            </ProtectedRoute>
          } />
          <Route path="/tailspin/html-collateral" element={
            <ProtectedRoute>
              <TailspinOnboardingGuard>
                <TailspinLayout>
                  <HtmlCollateralCreate />
                </TailspinLayout>
              </TailspinOnboardingGuard>
            </ProtectedRoute>
          } />
          <Route path="/tailspin/html-collateral/:slug" element={
            <ProtectedRoute>
              <TailspinOnboardingGuard>
                <TailspinLayout>
                  <HtmlCollateral />
                </TailspinLayout>
              </TailspinOnboardingGuard>
            </ProtectedRoute>
          } />

          {/* Code First PoC */}
          {/* <Route path="/code-first-poc" element={<CodeFirstCollateral />} /> */}

          {/* Admin Dashboard - SuperAdmin Only with Layout */}
          <Route path="/admin/dashboard" element={
            <SuperAdminRoute>
              <TailspinLayout>
                <AdminDashboard />
              </TailspinLayout>
            </SuperAdminRoute>
          } />

          {/* Subscription Management Routes */}
          <Route path="/subscription/manage" element={
            <ProtectedRoute>
              <ManageSubscription />
            </ProtectedRoute>
          } />
          <Route path="/subscription/success" element={
            <ProtectedRoute>
              <SubscriptionSuccess />
            </ProtectedRoute>
          } />
          <Route path="/subscription/cancel" element={
            <ProtectedRoute>
              <SubscriptionCancel />
            </ProtectedRoute>
          } />

          {/* CRM Analysis — SuperAdmin only */}
          <Route path="/crmanalysis/:tenantname/dataSync" element={
            <SuperAdminRoute>
              <CrmDataSync />
            </SuperAdminRoute>
          } />
          <Route path="/crmanalysis/:tenantname/analysis" element={
            <SuperAdminRoute>
              <CrmAnalysis />
            </SuperAdminRoute>
          } />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      </CrmAnalysisProvider>
    </Router>
  );
}

export default App;
